import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Accounts_Verify, Accounts_Reverify } from '../api/API_Accounts';
import DRLogo from '../Assets/Images/DR_Logo.png';
import REDLogo from '../Assets/Images/RED_Logo.png';
import Background from '../Assets/Images/NSDAPS_Main_Facade.png';
import FormLandingLogin from '../components/LoginRegister/Form_Landing_LogIn';
import FormLandingRegister from '../components/LoginRegister/Form_Landing_Register';
// import Test_Rooms_List from '../components/Test_Rooms_List';
import UISubwindows from '../components/UI_Subwindows';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import { Context_UI } from '../Contexts/Context_UI';
import Subwindow_Modal_ResetPassword_EmailSent from '../components/Subwindow_Modal_ResetPassword_EmailSent';
import UI_Divider from '../components/ERUMAUI/UI_Divider';
import UI_Input_Text from '../components/ERUMAUI/UI_Input_Text';
import { useAccounts } from '../Contexts/Context_Accounts';
import { useStatus } from '../Contexts/Context_Status_Global';



export default function DR_ResetPassword() {
    const UI = useContext(Context_UI);
    const [Loading, Loading_Set] = useState(false);
    const [Verify_State_Message, Verify_State_Message_Set] = useState("Inactive");
    const [Verify_State, Verify_State_Set] = useState("Inactive");
    const Navigate = useNavigate();
    const { User_Reset_Password } = useAccounts();
    const { Confirmer_Confirm } = useStatus();

    useEffect(() => {
        UI.Page_Navigator_Set(Navigate);
        setTimeout(function () {
            // window.Initial_Properties_Set();
            window.LoadingScreen_Hide();
        }, 2000);
    }, []);

    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_ResetPassword_EmailSent",
            Component: <Subwindow_Modal_ResetPassword_EmailSent />
        }
    ]);

    const Location = useLocation();
    const Parameters = new URLSearchParams(Location.search);
    const Verify_Token = Parameters.get('vt');

    const hasVerified = useRef(false);
    const Resend = () => {
        Verify_State_Set("Verifying");
        Verify_State_Message_Set("Active");
        Accounts_Reverify({ Token: Verify_Token })
            .then((res) => {
                // console.log(res.data.message);
                if (res.status === 200) {
                    Verify_State_Set("Reverify_Sent");
                    Verify_State_Message_Set("Verified");
                }
            })
            .catch((err) => {
                // console.log(err.response?.data?.code);
                let Error = err.response?.data?.code;
                switch (Error) {
                    case "NOTOKEN":
                        Verify_State_Set("Token_Nothing");
                        break;
                    case "INVALIDTOKEN":
                        Verify_State_Set("Token_Invalid");
                        break;
                    case "ALRVERIFIED":
                        Verify_State_Set("Token_Irrelevant");
                        break;
                    case "EXPIRED":
                        Verify_State_Set("Token_Expired");
                        break;
                    case "ERROR":
                        Verify_State_Set("Error");
                        break;
                }
                // Verify_State_Set("Error");
                Verify_State_Message_Set(err.response?.data?.message || "Inactive");
            });
    }

    const Handle_Email = async () => {
        const Passed = await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "Input_Email",
                Prompt: "This field is required."
            },
            {
                Type: "Email",
                ID: "Input_Email",
                Prompt: "The email is not of valid format."
            }
        ]);
        if (Passed) {
            UI.Element_Attribute_Set("Landing_Form_Message", "State", "Active");
            UI.Element_Attribute_Set("Landing_Form_Message", "Indicator", "Neutral");
            UI.Element_InnerHTML_Set("Landing_Form_Message_Text", `Contacting the server. This may take a minute.`);
            Loading_Set(true);
            const Result = await User_Reset_Password(UI.Element_Value_Get("Input_Email"));
            if (Result.State === "Error") {
                UI.Element_Attribute_Set("Landing_Form_Message", "State", "Active");
                UI.Element_Attribute_Set("Landing_Form_Message", "Indicator", "Error");
                UI.Element_InnerHTML_Set("Landing_Form_Message_Text", `Password reset failed because we can't find the email.`);
            }
            // if (Result.data)
            // console.log("Sent.");
            Loading_Set(false);
            
        }
    }

    return (
        <>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />
            <div className="Landing">
                <div className="Landing_Content">
                    <div className="Landing_Logo_DR">
                        <img className="Landing_Logo_DR_Image" src={DRLogo} draggable="false" loading='lazy' alt='' />
                        <p>{Loading}</p>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div className='Landing_Verify'>
                            <h2 className='General_Title'>
                                Reset password
                            </h2>
                            <p className='General_Paragraph'>
                                Please enter the email associated with your account. You will be sent a link that you must open in order to change your password.
                            </p>
                            <UI_Divider />
                            <UI_Input_Text
                                id="Input_Email"
                                Input_Type='email'
                                Label_Text="Email address: "
                                Required={true}
                                Input_Placeholder="Enter your account email address."
                            />

                            <div
                                className='Landing_Form_Message'
                                id="Landing_Form_Message"
                                State={Verify_State_Message == "Active" ? "Active" : "Inactive"}
                                Indicator={Verify_State === "Verifying" ? "Neutral" : "Positive"}
                            >
                                <p className='Landing_Form_Message_Text' id='Landing_Form_Message_Text'>
                                    {Verify_State === "Verifying" ?
                                        "Contacting the server. This may take a minute."
                                        :
                                        ""
                                    }
                                </p>
                            </div>
                            {!Loading ?
                                <>
                                    <button type="submit" className="General_Button" Clickability={Loading ? "Disabled" : undefined} Override_Form_Composition disabled={Loading == true ? true : false} onClick={Handle_Email}>
                                        Send verification email
                                    </button>
                                    <UI_Divider />
                                    <button type="submit" className="General_Button" Clickability={Loading ? "Disabled" : undefined} Override_Form_Composition disabled={Loading == true ? true : false} onClick={() => Navigate("/")}>
                                        Go back to login
                                    </button>
                                </>
                                :
                                ""
                            }
                            
                        </div>

                    </div>
                    <div className="Landing_Logo_RED">
                        <img className="Landing_Logo_RED_Image" src={REDLogo} draggable="false" loading='lazy' alt='' />
                    </div>
                    <div className="Landing_Version">
                        <p className="Landing_Version_Text">

                        </p>
                    </div>
                </div>
                <div className="Landing_Banner">
                    <img className="Landing_Banner_Image" src={Background} draggable="false" loading='lazy' alt='' />
                </div>
            </div>
        </>

    )
}